import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: `${Routes.CONFIRM_TRUSTED_USER}/:email/:mainEmail/:projectId`,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/ConfirmTrustedUserContainer'),
      import('./reducers')
    ])

    injectReducer(store, { key: 'confirmTrustedUser', reducer: reducer.default })

    cb(null, module.default)
  }
})
